import { type ActionListResponse, type ActionList } from '../types';
import promotionSeializer from './promotion.serializer';

export default function promotionsSerializer(
  data: ActionListResponse,
): ActionList {
  return {
    largeBanners: data.banners?.SIZE_2_BY_2?.map((banner) =>
      promotionSeializer(banner),
    ),
    smallBanners: data.banners?.SIZE_2_BY_1?.map((banner) =>
      promotionSeializer(banner),
    ),
    highlightedProducts: data.highlighted?.map((action) =>
      promotionSeializer(action),
    ),
    products: data.products?.map((action) => promotionSeializer(action)) ?? [],
  };
}
